import {
    useTradingWebsocket,
    useWalletWebsocket,
    getSpotTradingBalances,
    getFuturesTradingBalances,
    requestBalances,
    useTradingConnect,
    useWalletConnect,
} from '@web/walter-lib/stream'
import { useAuthSwr } from '~api/swr/useAuthSwr'
import { socketKeys } from '~api/swr/keys'

const refreshInterval = 15000

interface Props {
    shouldRequest?: boolean
}

export const useSpotTradingBalances = () => {
    const websocket = useTradingWebsocket()
    const { connected } = useTradingConnect()
    return useAuthSwr(connected ? socketKeys.getSpotTradingBalances : null, () => getSpotTradingBalances(websocket), {
        refreshInterval,
    })
}

export const useFuturesTradingBalances = (props?: Props) => {
    const { shouldRequest } = props || {}
    const websocket = useTradingWebsocket()
    const { connected } = useTradingConnect()
    return useAuthSwr(
        connected && shouldRequest ? socketKeys.getFuturesTradingBalances : null,
        () => getFuturesTradingBalances(websocket),
        {
            refreshInterval,
        }
    )
}

export const useWalletBalances = () => {
    const websocket = useWalletWebsocket()
    const { connected } = useWalletConnect()
    return useAuthSwr(connected ? socketKeys.getWalletBalances : null, () => requestBalances(websocket))
}
